<template>
  <div class="big-box">
    <div class="scroll-box">
      <img :src="backgroundImage" alt="" class="big-box-img" />
      <div class="big-body">
        <img :src="tapTopUrl" alt="" class="tap-top" />
        <div class="pd8">
          <!-- 主题文字 -->
          <div
            class="theme-word"
            :style="`color: ${customerPaperwork.titleColor};`"
          >
            <div class="title">{{ customerPaperwork.title }}</div>
            <div class="desc">{{ customerPaperwork.desc }}</div>
          </div>
          <div class="prize-box">
            <div
              class="prize-item"
              v-for="(item, index) in productList"
              :key="item.assetId"
            >
              <div class="prize-img">
                <img :src="item.logo" alt="" v-if="item.logo" />
                <div
                  class="prize-total"
                  v-if="index == 0 && item.totalAmount > 0"
                >
                  剩余{{ item.totalAmount }}份
                </div>
                <div class="prize-total" v-else-if="index == 1">已领取</div>
                <div class="mask-box" v-else-if="index == 2">
                  <img
                    src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/preview/sold-out.svg"
                    alt=""
                    class="out-stock"
                  />
                </div>
              </div>
              <div class="prize-name">{{ item.title }}</div>
            </div>
          </div>
          <div class="publish-box">
            <div class="publish-word">做任务得口令，输入口令参与盖楼</div>
            <div class="publish-btn">发布</div>
          </div>
          <div class="footer-box">
            <div class="footer-header">
              <div :class="{ 'footer-item': true, active: currentIndex == 0 }">
                全部楼层
              </div>
              <div class="footer-item">我的楼层</div>
            </div>
            <div class="footer-content">
              <div
                class="footer-item"
                v-for="item in footerList"
                :key="item.value"
              >
                <div class="user-box">
                  <img :src="item.avatar" alt="" class="avatar-img" />
                  <div class="user-info">
                    <div class="user-name">{{ item.name }}</div>
                    <div class="user-time">{{ item.time }}</div>
                    <div class="win-box">
                      <img :src="item.winUrl" alt="" v-if="item.winUrl" />
                      <div class="win-word" v-if="item.isWin">
                        恭喜中奖！双盖保温杯
                      </div>
                    </div>
                  </div>
                </div>
                <div class="footer-btn">{{ item.value }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="main-btn">
        <img :src="btnUrl" alt="" v-if="btnUrl" />
        <div class="btn-word" :style="`color: ${customerPaperwork.btnColor};`">
          做任务 得口令
        </div>
        <img
          class="bargain-btn-icon"
          src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/preview/sweep-light.svg"
          alt=""
        />
      </div>
    </div>
    <div class="footer-title">图为预览效果，以实际投效果为准</div>
  </div>
</template>
<script>
export default {
  name: "",
  components: {},
  mixins: [],
  props: {
    ruleForm: {
      type: Object,
      default: () => ({}),
    },
    ruleDTO: {
      type: Object,
      default: () => ({}),
    },
    customerPaperwork: {
      type: Object,
      default: () => ({}),
    },
    templateObj: {
      type: Object,
      default: () => ({}),
    },
    backgroundImage: {
      type: String,
      default: "",
    },
    productList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentIndex: 0,
      currentObj: {},
      currentPrize: [],
      currentIndex: 0,
      prizeList: [],
      tapTopUrl:
        "https://cdn-image.yucrm.cn/images/dyAssets/images/preview/shop_top.png",
      inviteNumImg:
        "https://cdn-image.yucrm.cn/images/dyAssets/images/preview/yqrs_footer.png",
      footerList: [
        {
          avatar:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/decorate/preview-avatar.png",
          name: "娜娜",
          time: "2026-06-01 13:00:28",
          value: "10楼",
          isWin: false,
        },
        {
          avatar:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/decorate/preview-avatar.png",
          name: "娜娜",
          time: "2026-06-01 13:00:28",
          value: "9楼",
          isWin: true,
          winUrl:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/preview/win-prize-icon.png",
        },
        {
          avatar:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/decorate/preview-avatar.png",
          name: "娜娜",
          time: "2026-06-01 13:00:28",
          value: "8楼",
          isWin: false,
        },
        {
          avatar:
            "https://cdn-image.yucrm.cn/images/jd-front-platform/images/decorate/preview-avatar.png",
          name: "娜娜",
          time: "2026-06-01 13:00:28",
          value: "7楼",
          isWin: false,
        },
      ],
    };
  },
  computed: {
    tabUrl() {
      return this.customerPaperwork.tabUrl
        ? this.customerPaperwork.tabUrl
        : this.templateObj.url3;
    },
    btnUrl() {
      return this.customerPaperwork.url2
        ? this.customerPaperwork.url2
        : this.templateObj.url2;
    },
  },
  watch: {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.big-box {
  position: relative;
  width: 300px;
  height: 580px;
  box-shadow: 0px 4px 20px 0px rgba(18, 10, 60, 0.15);
  border-radius: 24px;
  border: 1px solid #ffffff;
  padding: 8px;
  margin-left: 231px;
  z-index: 999;
  background-color: #ffffff;

  .scroll-box {
    position: relative;
    width: 284px;
    height: 560px;
    overflow: hidden;
    border-radius: 24px;
  }
  .big-box-img {
    border-radius: 24px;
    width: 100%;
  }
  .big-body {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .tap-top {
      padding-top: 10px;
      width: 100%;
    }
    .pd8 {
      width: 100%;
      height: 100%;
      margin-top: 18px;
      // padding: 8px;
      box-sizing: border-box;
      position: relative;
      .theme-word {
        // position: absolute;
        display: flex;
        flex-direction: column;
        align-items: center;
        // top: 18px;
        width: 100%;
        > div:first-child {
          height: 16px;
          font-weight: bold;
          font-size: 15px;
          margin-bottom: 10px;
        }
        > div:last-child {
          height: 11px;
          font-size: 11px;
          opacity: 0.7;
        }
      }
      .prize-box {
        padding: 10px 6px 0;
        margin: 25px auto 0;
        width: 245px;
        height: 116px;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow-x: auto;
        .prize-item {
          flex-shrink: 0;
          margin-right: 5px;
          width: 70px;
          height: 88px;
          background: #ffffff;
          border-radius: 5px 5px 5px 5px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .prize-img {
            position: relative;
            width: 64px;
            height: 64px;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              border-radius: 5px 5px 5px 5px;
            }
            .prize-total {
              position: absolute;
              top: 0;
              left: 0;
              padding: 0 4px;
              height: 14px;
              background: rgba(0, 0, 0, 0.6);
              border-radius: 5px 0px 5px 0px;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 8px;
              color: #ffffff;
              line-height: 14px;
              text-align: center;
              font-style: normal;
              text-transform: none;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .mask-box {
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background: rgba(0, 0, 0, 0.6);
              border-radius: 5px 5px 5px 5px;
              .out-stock {
                width: 41px;
                height: 41px;
                object-fit: cover;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
              }
            }
          }

          .prize-name {
            margin-top: 4px;
            width: 64px;
            height: 11px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 11px;
            color: #333333;
            line-height: 11px;
            text-align: center;
            font-style: normal;
            text-transform: none;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        &::-webkit-scrollbar {
          width: 1px;
          height: 2px;
        }
        &::-webkit-scrollbar-track {
          background: #f3f3f3;
        }
      }

      .publish-box {
        position: relative;
        padding: 11px;
        margin: 16px auto 0;
        width: 265px;
        height: 53px;
        background: #ffffff;
        border-radius: 9px 9px 9px 9px;
        .publish-word {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 11px;
          color: #999999;
          line-height: 11px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
        .publish-btn {
          position: absolute;
          right: 5px;
          bottom: 5px;
          width: 38px;
          height: 20px;
          background: linear-gradient(356deg, #51473a 0%, #2c2822 100%);
          border-radius: 22px 22px 22px 22px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 10px;
          color: #ffffff;
          line-height: 20px;
          text-align: center;
          font-style: normal;
          text-transform: none;
        }
      }
      .footer-box {
        margin: 12px auto 0;
        padding: 15px;
        width: 269px;
        height: 265px;
        border-radius: 11px 11px 11px 11px;
        overflow: hidden;
        .footer-header {
          width: 100%;
          display: flex;
          align-items: center;
          .footer-item {
            text-align: center;
            width: 50%;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #666666;
            line-height: 12px;
            text-align: center;
            font-style: normal;
            text-transform: none;
          }
          .active {
            font-weight: 500;
            color: #333333;
          }
        }
        .footer-content {
          margin-top: 12px;
          .footer-item {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            margin-bottom: 12px;
            padding: 11px;
            // height: 48px;
            background: rgba(255, 255, 255, 0.7);
            border-radius: 6px 6px 6px 6px;
            .avatar-img {
              width: 30px;
              height: 30px;
              border-radius: 50%;
            }
            .user-box {
              display: flex;
              // align-items: center;

              .user-info {
                margin-left: 7px;
                .user-name {
                  font-family: PingFang SC, PingFang SC;
                  font-weight: 500;
                  font-size: 11px;
                  color: #333333;
                  line-height: 11px;
                  text-align: left;
                  font-style: normal;
                  text-transform: none;
                }
                .user-time {
                  margin-top: 4px;
                  font-family: PingFang SC, PingFang SC;
                  font-weight: 400;
                  font-size: 10px;
                  color: #999999;
                  line-height: 10px;
                  text-align: left;
                  font-style: normal;
                  text-transform: none;
                }
                .win-box {
                  margin-top: 4px;
                  display: flex;
                  align-items: center;
                  img {
                    width: 9px;
                    height: 9px;
                    object-fit: cover;
                  }
                  .win-word {
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 9px;
                    color: #b56100;
                    line-height: 9px;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;
                  }
                }
              }
            }
            .footer-btn {
              width: 31px;
              height: 15px;
              background: linear-gradient(78deg, #fdefd4 100%, #f4d184 100%);
              border-radius: 4px 4px 4px 4px;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 9px;
              color: #b57d00;
              line-height: 13px;
              text-align: center;
              font-style: normal;
              text-transform: none;
              border: 1px solid #e2b758;
            }
          }
        }
      }
    }
  }
  .main-btn {
    position: sticky;
    left: 13%;
    bottom: 14px;
    width: 212px;
    height: 32px;
    background: #ffffff;
    border-radius: 19px 19px 19px 19px;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .btn-word {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-family: PingFang SC, PingFang SC;
      font-weight: 600;
      font-size: 12px;
      color: #ffffff;
      line-height: 12px;
      text-align: center;
      font-style: normal;
      text-transform: none;
    }
    .bargain-btn-icon {
      width: 212px;
      height: 32px;
      position: absolute;
      left: 0;
      bottom: 0;
      animation: identifier 2s infinite;
      border-radius: 19px 19px 19px 19px;
    }
    @keyframes identifier {
      0% {
        transform: translateX(-30px);
      }
      100% {
        transform: translateX(100%);
      }
    }
  }
  .footer-title {
    margin-top: 20px;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 14px;
    text-align: center;
  }
}
</style>
